<template>
  <div class="page page-eat-right">

    <div class="hero eat-right-hero no-hero-img">

      <div class="hero-content middle">
        <h1 class="page-title">
          Eat Right
          <small>Nutrition</small>
        </h1>
      </div>

      <div class="wave-bottom">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="140px" viewBox="20 -20 300 100" xml:space="preserve">
          <path class="fill-primary" opacity=".075" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729 c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"></path>
          <path class="fill-primary" opacity=".075" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729 c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"></path>
          <path class="fill-primary" opacity="0" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716 H42.401L43.415,98.342z"></path>
          <path class="fill-white" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428 c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"></path>
        </svg>
      </div>

    </div>

    <div class="eat-right-content">

      <div class="container">
        <p class="lead">If your plan is not sustainable, your goal is not attainable.</p>
        <div class="fc-alternate">
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/thumb/gym-tired.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                <p>No matter what kind of results you may have experienced from following some crazy fad diet... grapefruit only, cabbage soup diet, no carbs ever, no fun ever again diet... you will eventually fall off the wagon, feeling worse than when you started.</p>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/thumb/planning.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                <p class="font-weight-bold">Its time to break this vicious cycle once and for all!</p>
                <p>I will help you create a realistic plan and support you every step of the way. There is <span class="font-weight-bold">no short cut</span>, <span class="font-weight-bold">no quick fix</span>, and <span class="font-weight-bold">no magic pill</span> that will get you lasting results. Only through changing what you eat and working hard will you be truly successful.</p>
              </div>
            </div>
          </div>
        </div>
        <p class="lead">Let’s do this!</p>
      </div>

      <!-- Services -->
      <Services />

    </div>

  </div>
</template>

<script>
import Services from '@/components/Services'

export default {
  components: {
    Services
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.eat-right-hero {
  margin-bottom: 20px;
  background: $bb-blue-lightest;
  // background: $bb-blue-lightest url('../assets/img/pattern/nutrition.jpg') repeat 0 0;
  // background-size: (144px * 2.5) (138px * 2.5);

  .wave-bottom {
    position: absolute;
    right: 0;
    left: 0;
    bottom: -20px;
  }

  @include media-breakpoint-up(md) {
    margin-bottom: 40px;
  }
}

.eat-right-content {
  p {
    &.lead {
      text-align: center;

      &:first-child {
        max-width: 330px;
        margin: 0 auto 3rem auto;

        @include media-breakpoint-up(md) {
          max-width: none;
        }
      }

      &:last-child {
        margin: 3rem 0;
      }
    }
  }
}
</style>
